import React from 'react';
import { Stack, Typography, Button, ButtonBase, Avatar, Modal, Box } from '@mui/material';
import logo from '../../../logo_complet_bleu.png';
import { useNavigate } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import MenuIcon from '@mui/icons-material/Menu';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
// import { IconMenu2 } from '@tabler/icons';
const style = {
    position: 'absolute',
    top: 0,
    right: 0,
    // transform: 'translate(-50%, -50%)',
    width: '70vw',
    maxWidth: 400,
    height: '100vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    border: 0,
    p: 4
};
const Header = () => {
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width: 800px)');
    const [toggle, setToggle] = React.useState(false);
    const theme = useTheme();
    const handleToggle = () => setToggle(!toggle)
    return(
        <Stack direction="row" sx={{ pt: '30px', justifyContent: 'space-between', maxWidth: '1050px', width: '90%' }}>
            <Stack onClick={() => navigate('/')} direction="row" sx={{ alignItems: 'center', cursor: 'pointer' }} spacing={1}>
                <img src={logo} height={'auto'} width={200} alt="logo" />
            </Stack>
            {isMobile ? (
                <Stack direction="row" sx={{ justifyContent: 'center', alignItems: 'center' }} spacing={10}>
                    <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                        <Avatar
                            variant="rounded"
                            sx={{
                                ...theme.typography.commonAvatar,
                                ...theme.typography.mediumAvatar,
                                transition: 'all .2s ease-in-out',
                                backgroundColor: '#d2e8f8',
                                color: '#135485',
                                '&:hover': {
                                    background: '#0c3859',
                                    color: '#d2e8f8'
                                }
                            }}
                            onClick={handleToggle}
                            // color="inherit"
                        >
                            <MenuIcon sx={{ color: '#135485', '&:hover': {
                                    backgroundColor: '#0c3859',
                                    color: '#135485'
                                } }} stroke={1.5} size="1.3rem" />
                        </Avatar>
                    </ButtonBase>
                </Stack>
            ) : (
                <>
                    <Stack direction="row" sx={{ justifyContent: 'center', alignItems: 'center' }} spacing={10}>
                        {/* <Typography onClick={() => navigate('/services')} sx={{ cursor: 'pointer',color: "black", fontWeight: 'bold', fontSize: 16, fontFamily: 'Afacad'}}>Services</Typography> */}
                        <Typography onClick={() => navigate('/a-propos')} sx={{ cursor: 'pointer',color: "black", fontWeight: 'bold', fontSize: 16, fontFamily: 'Afacad'}}>A propos</Typography>
                        <Typography onClick={() => navigate('/contact')} sx={{ cursor: 'pointer',color: "black", fontWeight: 'bold', fontSize: 16, fontFamily: 'Afacad'}}>Contact</Typography>
                    </Stack>
                    {/* <Button variant='contained' disableElevation sx={{ backgroundColor:'#1970B2', height: 40, fontSize: 16, width: 125, textTransform: 'lowercase', fontFamily: 'Afacad' }}>
                        Connexion
                    </Button> */}
                </>
            )}
            {toggle ? (
                <Modal open={toggle} onClose={() => setToggle(false)}>
                    <Box sx={style}>
                    <Stack direction="row" sx={{ justifyContent: 'flex-end', alignItems: 'center' }} spacing={10}>
                        <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                            <Avatar
                                variant="rounded"
                                sx={{
                                    ...theme.typography.commonAvatar,
                                    ...theme.typography.mediumAvatar,
                                    transition: 'all .2s ease-in-out',
                                    background: '#d2e8f8',
                                    color: '#135485',
                                    '&:hover': {
                                        background: '#0c3859',
                                        color: '#d2e8f8'
                                    }
                                }}
                                onClick={handleToggle}
                                color="inherit"
                            >
                                <CloseIcon stroke={1.5} size="1.3rem" />
                            </Avatar>
                        </ButtonBase>
                    </Stack>
                    <Stack direction="column" sx={{ height: '100%', width: '100%', alignItems: 'center', mt: 8}} spacing={6}>
                        <Typography onClick={() => navigate('/')} sx={{ cursor: 'pointer',color: "black", fontWeight: 'bold', fontSize: 30, fontFamily: 'Afacad'}}>Accueil</Typography>
                        {/* <Typography onClick={() => navigate('/services')} sx={{ cursor: 'pointer',color: "black", fontWeight: 'bold', fontSize: 30, fontFamily: 'Afacad'}}>Services</Typography> */}
                        <Typography onClick={() => navigate('/a-propos')} sx={{ cursor: 'pointer',color: "black", fontWeight: 'bold', fontSize: 30, fontFamily: 'Afacad'}}>A propos</Typography>
                        <Typography onClick={() => navigate('/contact')} sx={{ cursor: 'pointer',color: "black", fontWeight: 'bold', fontSize: 30, fontFamily: 'Afacad'}}>Contact</Typography>
                        {/* <Button variant='contained' disableElevation sx={{ backgroundColor:'#1970B2', height: 'auto', fontSize: 24, width: 230, textTransform: 'lowercase', fontFamily: 'Afacad' }}>
                            Connexion
                        </Button> */}
                    </Stack>
                    </Box>
                </Modal>
            ) : null }
        </Stack>
    )
}

export default Header;